var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"footer-links"},_vm._l((_vm.footerLinks),function(link){return _c('li',{key:link.url},[_c('a',{attrs:{"href":link.url,"target":"_blank"}},[_vm._v(_vm._s(link.label))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }